import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import FloatingActions from '@/components/FloatingActions';
import InstallPrompt from '@/components/InstallPrompt';
// Every route opens at the top (Pricing, Membership, Dashboard, Legal...),
// except Back/Forward, a return to browse results, and the language toggle.
import ScrollToTop from '@/components/ScrollToTop';
import { useI18n } from '@/i18n/LanguageContext';
import { trackPageView } from '@/lib/tracking';
import ResumePurchaseBanner from '@/components/ResumePurchaseBanner';
import TrainingBanner from '@/components/TrainingBanner';



const SiteShell: React.FC = () => {
  const { fading } = useI18n();
  const location = useLocation();
  const last = useRef<string>('');

  // Anonymous, first-party page-view tracking. No fingerprinting, no third
  // party pixels — see src/lib/tracking.ts. Fire-and-forget so navigation is
  // never delayed by the tracking call.
  useEffect(() => {
    const key = location.pathname + location.search;
    if (last.current === key) return;
    last.current = key;
    trackPageView();
  }, [location.pathname, location.search]);

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      {/* Must sit INSIDE the router: a new route opens at the top unless the
          navigation is a Back/Forward, a return to browse results, or the
          language toggle. See src/components/ScrollToTop.tsx. */}
      <ScrollToTop />
      {/* TEST/TRAINING accounts only (mkt_test_accounts). Renders nothing for real users. */}
      <TrainingBanner />
      <Header />
      {/* "You were buying X — Continue" for anyone who drifted off mid-purchase. */}
      <ResumePurchaseBanner />

      <main className={`flex-1 transition-opacity duration-200 ${fading ? 'opacity-0' : 'opacity-100'}`}>
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      {/* Sticky conversion actions: Start Now (plan picker) + WhatsApp. */}
      <FloatingActions />
      {/* "Add to Home Screen" — self-gating: renders nothing unless
          src/lib/pwa.ts says this visitor qualifies (2nd visit or a key
          action, not installed, not dismissed in the last 30 days). */}
      <InstallPrompt />
    </div>


  );
};

export default SiteShell;
